import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Remove StrictMode in production — StrictMode causes double-render
// which inflates INP and FCP measurements in development.
// In production we render once for maximum performance.
root.render(<App />);

// Web Vitals reporting (Vercel Speed Insights handles this via SpeedInsights component)
reportWebVitals();
